import { getAccessToken } from "@/helpers/auth-helpers";
import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import ICustomer from "@/interfaces/customer.interfaces";
import customerService from "@/services/customer.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateCustomerProps = UpdateByIdProps<FormData>;

export type UseUpdateCustomerReturn = {
  update: (props: UpdateCustomerProps) => Promise<ICustomer>;
} & UseLoadingReturn;

const useUpdateCustomer = (): UseUpdateCustomerReturn => {
  const accessToken = getAccessToken();

  if (!accessToken) {
    throw new Error("Access token is not available");
  }

  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<
    FormData,
    ICustomer
  >({
    operation: (formData, customerId) => customerService.update(formData, customerId, accessToken),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateCustomer;
